<template>
  <v-select
      :items="formattedCategoryList" 
      label="Kategoriler"
      item-title="title"
      item-value="id"
      required
  ></v-select>
</template>


<script>
import { useStore } from 'vuex';
import { computed } from 'vue';

export default {
    name: "CategorySelect",
    setup() {
        const store = useStore();
        // sellerList'i store'dan al
        const categoryList = computed(() => store.state.categoryList);

        // Kategorileri formatla
        const formattedCategoryList = computed(() => {
            return categoryList.value.map(category => {
                // Eğer parent doluysa, "ana kategori -> parent kategori" formatında döndür
                if (category.children && category.children.length > 0) {
        return category.children.map(child => {
            return {
                id: child.id,
                title: `${category.title} -> ${child.title}`, // Ana kategori -> Çocuk kategori formatında döndür
            };
        });
    }
                return {
                    id: category.id,
                    title: category.title, // Parent yoksa, orijinal kategoriyi döndür
                };
            });
        });

        return {
            formattedCategoryList,
        };
    },
}
</script>